import { defineRouting, findDomain, replaceLocale } from "@trydig/next/i18n";
import { defineNavigation } from "@trydig/next/i18n/navigation";
import {
	addLeadingSlash,
	dedupeArray,
	removeTrailingSlash,
} from "@trydig/utils";
import { BASE_URL } from "@/constants";
import { getBaseUrl } from "@/lib/utils";
import { countryCodes } from "../../generated/countries";

const languages = ["en", "no", "de", "sv", "da"];
export const countries = countryCodes;

export const localesWithCountries = languages.flatMap((locale) => {
	return countryCodes.map((country) => `${locale}-${country.country}`);
});

export const seoLocales = dedupeArray([
	...countries.map((country) => `${country.language}-${country.country}`),
	...localesWithCountries.filter((c) => c.includes("en-")),
]);

export const routing = defineRouting({
	languages,
	defaultLocale: "en-NO",
	locales: localesWithCountries,
	localePrefix: "always",
	/**
	 * Sets the preferred countries when multiple countries are available for a language
	 */
	groups: ["categories", "products", "pages", "configuration"],
	seoLocales,
	removeSegments: ["home", ...languages],
});

export const {
	Link,
	Form,
	permanentRedirect,
	redirect,
	usePathname,
	useRouter,
	useGeo,
	SearchParamLink,
	addLocale,
} = defineNavigation(routing);

export const withDomain = (locale: string, uri: string) => {
	return removeTrailingSlash(
		`${getBaseUrl()}${addLeadingSlash(
			replaceLocale(uri, locale || routing.defaultLocale, routing),
		)}`,
	);
};

export const getDomainUrl = (locale: string) => {
	const domain = findDomain(locale, routing);
	if (domain) {
		return new URL(`${domain.protocol || "https"}://${domain.domain}`);
	}
	return new URL(BASE_URL);
};
